import React, { useEffect, useReducer, useRef } from 'react';
import {
  Button,
  FormHelperText,
  Grid,
  MenuItem,
  Modal,
  Select,
  InputAdornment,
  TextField,
  Typography, Badge
} from '@material-ui/core';
import Input from '@material-ui/core/Input';
//import ImageGallery from 'react-image-gallery';
import DateFnsUtils from '@date-io/date-fns';
import {
  DatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import { NotificationManager } from 'react-notifications';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { client } from '../../config/apollo';
import {
  setBookingCompletedStep,
  CreateInProgressBooking,
  setPendingBooking,
  SelectedChefDetails,
  SelectedChefAvailability,
  setSelectedDate,
  setSelectedSlot
} from '../../redux/bookings';
import { CREATE_IN_PROGRESS_BOOKING } from '../../graphql/mutations/booking';
import { DISHES_BY_CHEF } from '../../graphql/queries/dishes';
import { primaryColor, webFont } from '../../config/theme';
import AddressComp from './InProgress3';
import DishComponent from './Dish-Component';
import './booking.css';
import format from 'date-fns/format';
import { Close } from '@material-ui/icons';
import Divider from '@material-ui/core/Divider';
import { GET_CALENDAR_SLOTS } from '../../graphql/queries/schedule';

const weekDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const defaultChefImg = '/images/simple-chef.webp';

class FrDateFnsUtils extends DateFnsUtils {
  startOfMonth(date) {
    return moment(date).startOf('month').toDate();
  }

  getDatePickerHeaderText(date) {
    return format(date, 'd MMMM', { locale: this.locale })
  }
}

const InProgressRecurring1 = (props) => {
  const dispatch = useDispatch();
  const {
    chefAvailability,
    diner,
    userId,
    selectedChef,
    selectedChefId,
    selectedDate,
    selectedSlot,
    customPriceRange
  } = useSelector(store => ({
    diner           : store.user.diner,
    userId          : store.auth.userId,
    customPriceRange: store.bookings.customPriceRange,
    pendingBooking  : store.bookings.pendingBooking,
    selectedChef    : store.bookings.selectedChef,
    selectedDate    : store.bookings.selectedDate,
    selectedSlot    : store.bookings.selectedSlot,
    selectedChefId  : store.bookings.selectedChefId,
    chefAvailability: store.bookings.chefAvailability
  }), shallowEqual);

  const [state, setState] = useReducer((oldProps, newProps) => ({ ...oldProps, ...newProps }), {
    availability          : [],
    chefDetails           : null,
    chefDishes            : [],
    description           : '',
    dinerSize             : 2,
    galleryDishes         : [],
    isRecurring           : props.isRecurring || false,
    minDate               : moment().format('YYYY-MM-DD'),
    pickerRef             : false,
    repeatCount           : 1,
    repeatDays            : [],
    scheduleMonth         : moment().format('MM'),
    selectedMeridiem      : '',
    selectedMeridiemEnd   : '',
    selectedDishes        : [],
    selectedTimeHour      : 11,
    selectedTimeMinutes   : '00',
    selectedTimeHourEnd   : 11,
    selectedTimeMinutesEnd: '00',
    selectedDate          : 1,
    selectedMonth         : 'Jan',
    startPrice            : 500,
    endPrice              : 1000,
    priceErr              : false,
    priceErrMsg           : '',
    showAddress           : false,
    monthlySlots          : []
  });

  const fetchMonthlySlots = () => {
    if (!state.chef && !state.scheduleMonth) return;

    client.query({
        query      : GET_CALENDAR_SLOTS,
        variables  : {
          chefId: state.chef.id,
          start : moment(state.scheduleMonth, 'MM')
            .startOf('month')
            .format('YYYY-MM-DD'),
          end   : moment(state.scheduleMonth, 'MM')
            .endOf('month')
            .format('YYYY-MM-DD')
        },
        fetchPolicy: 'network-only'
      })
      .then(response => {
        setState({ monthlySlots: response.data })
      })
      .catch(err => console.error('ERROR FETCHING SLOTS FOR THE GIVEN MONTH', state.scheduleMonth, err));
    dispatch(SelectedChefAvailability(state.chef.id, state.selectedDate));
  };

  const handleDishClick = dishId => {
    const { chefDishes, selectedDishes } = state;
    const dish = chefDishes.find(item => item.id === dishId);
    const index = selectedDishes.findIndex(item => item.dishId === dishId);
    if (index < 0) {
      selectedDishes.push({ dishId, serves: dish.minDinerSize });
      NotificationManager.info(`${dish.name} added to booking`, 'Booking');
    } else {
      selectedDishes.splice(index, 1);
      NotificationManager.info(`${dish.name} removed from booking`, 'Booking');
    }

    setState({ selectedDishes });
  };

  const renderDishGalleryItem = item => {
    return (<DishComponent dish={item.dish} handleClick={handleDishClick} selectedDishes={state.selectedDishes}/>);
  };

  const openPicker = e => {
    setState({ pickerRef: !state.pickerRef })
  };

  const handleDateChange = d => {
    setState({
      selectedDate: new Date(d)
    });
  };

  const showAddressToggle = () => {
    setState({ showAddress: !state.showAddress })
  };
  // fetch all dishes by chef to show in carousel
  useEffect(() => {
    const now = moment();
    setState({
      selectedDate       : now.add(1, 'days').toDate(),
      selectedMonth      : now.add(1, 'days').format('MMM'),
      selectedTimeHour   : parseInt(now.add(2, 'hours').format('h')),
      selectedTimeMinutes: '00',
      selectedMeridiem   : now.format('A'),
      selectedTimeHourEnd: parseInt(now.add(2, 'hours').format('h')),
      selectedMeridiemEnd: now.format('A'),
      selectedTimeMinutesEnd: '00',
    });

    if (props.chef) {
      dispatch(SelectedChefDetails(props.chef.id));

      client
        .query({
          query      : DISHES_BY_CHEF,
          variables  : {
            chefId  : props.chef.id,
            live    : true,
            pageSize: 100
          },
          fetchPolicy: 'network-only'
        })
        .then(response => {
          if (response && !!response.data && response.data.dishesByChef) {
            setState({ chefDishes: response.data.dishesByChef.dishes });
          }
        })
        .catch(err => {
          console.log('ERR FETCHING CHEF DISHES: ', err)
        });
    }

  }, []);

  useEffect(() => {
    if (selectedDate) {
      const sDate = moment(selectedDate, 'YYYY-MM-DD');
      setState({ selectedDate: sDate.toDate(), selectedMonth: sDate.format('MMM') });
    }
  }, [selectedDate]);

  useEffect(() => {
    const availability = Array.isArray(chefAvailability) ? chefAvailability.length > 0 ? chefAvailability.map(chefAv => {
      return (`${moment(
        chefAv.start,
        'hh:mm a'
      ).format('LT')}- ${moment(chefAv.end, 'hh:mm a').format(
        'LT'
      )}`);
    }) : [] : [];

    let now = moment();
    let endTime = moment();
    if (availability.length) {
      now = moment(chefAvailability[0].start, 'hh:mm a')
      endTime = moment(chefAvailability[0].end, 'hh:mm a');
    }

    setState({
      availability,
      selectedTimeHour   : parseInt(now.format('h')),
      selectedMeridiem   : now.format('A'),
      selectedTimeMinutes: now.format('mm'),
      selectedTimeHourEnd: parseInt(endTime.format('h')),
      selectedMeridiemEnd: endTime.format('A'),
      selectedTimeMinutesEnd: endTime.format('mm'),
    });
  }, [chefAvailability]);

  useEffect(() => {
    if (selectedSlot) {
      if (!selectedSlot.start || !selectedSlot.end) return;


      const sTime = selectedSlot.start.split(':');
      const sTimeEnd = selectedSlot.end.split(':');

      if (sTime.length < 2 || sTimeEnd.length < 2) return;

      const sHours = parseInt(sTime[0]);
      const sHoursEnd = parseInt(sTimeEnd[0]);

      setState({
        selectedTimeHour      : sHours > 12 ? sHours - 12 : sHours,
        selectedTimeMinutes   : sTime[1], selectedMeridiem: sHours > 12 ? 'PM' : 'AM',
        selectedTimeHourEnd   : sHoursEnd > 12 ? sHoursEnd - 12 : sHoursEnd,
        selectedTimeMinutesEnd: sTimeEnd[1], selectedMeridiemEnd: sHoursEnd > 12 ? 'PM' : 'AM'
      });
    }
  }, [selectedSlot]);

  useEffect(() => {
    if (customPriceRange) {
      if (customPriceRange.startPrice) {
        setState({
          startPrice: customPriceRange.startPrice,
          endPrice  : customPriceRange.endPrice,
          dinerSize : customPriceRange.dinerSize
        })
      }
    }
  }, [customPriceRange]);

  useEffect(() => {
    if (selectedChef) {
      setState({ chef: selectedChef });

      if (selectedDate) {
        dispatch(SelectedChefAvailability(selectedChef.id, selectedDate));
      }
    }
  }, [selectedChef]);

  useEffect(() => {
    if (state.selectedDate && state.chef) {
      dispatch(SelectedChefAvailability(state.chef.id, state.selectedDate));
      fetchMonthlySlots();
    }
  }, [state.chef, state.selectedDate, state.scheduleMonth]);

  // update Items for, in carousel
  useEffect(() => {
    const dishesGallery = [];
    if (state.chefDishes.length) {
      state.chefDishes.forEach(dish => {
        dishesGallery.push({
          original   : dish.media ? dish.media.length > 0 ? dish.media[0].url : defaultChefImg : defaultChefImg,
          renderItem : renderDishGalleryItem,
          originalAlt: dish.name,
          thumbnail  : dish.media ? dish.media.length > 0 ? dish.media[0].url : defaultChefImg : defaultChefImg,
          dish
        });
      });

      setState({ galleryDishes: dishesGallery });
    }
  }, [state.chefDishes, state.selectedDishes]);

  const inProgress = () => {
    const {
      description,
      selectedDate,
      selectedMonth,
      selectedTimeHour,
      selectedTimeMinutes,
      dinerSize,
      selectedTimeHourEnd,
      isRecurring,
      repeatCount,
      repeatDays,
      selectedMeridiem,
      startPrice,
      endPrice,
      selectedTimeMinutesEnd,
      selectedMeridiemEnd
    } = state;

    const { city } = diner.address ? diner.address : {};

    if (!description) {
      NotificationManager.error('Description of the booking is required.', 'Booking');
      return;
    }
    if (!dinerSize) {
      NotificationManager.error('Diner size for the engagement is required.', 'Booking');
      return;
    }
    if (!startPrice) {
      NotificationManager.error('Min price for the engagement is required.', 'Booking');
      return;
    }
    if (!endPrice) {
      NotificationManager.error('Max price for the engagement is required.', 'Booking');
      return;
    }

    if (dinerSize < 1) {
      NotificationManager.error('Diner size cannot be less than 1.', 'Booking');
      return;
    }
    if (startPrice < 1) {
      setState({ priceErr: true, priceErrMsg: 'Min price cannot be less than 1' });
      return;
    }
    if (endPrice <= startPrice) {
      setState({ priceErr: true, priceErrMsg: 'Max price should be more than minimum price' });
      return;
    }

    const selectedTime = moment(selectedTimeHour + ':' + selectedTimeMinutes + ' ' + selectedMeridiem, 'HH:mm A');
    const selectedTimeEnd = moment(selectedTimeHourEnd + ':' + selectedTimeMinutesEnd + ' ' + selectedMeridiemEnd, 'HH:mm A');

    let format = 'HH:mm';
    let chefAvail = false;

    if (typeof chefAvailability === "object" && chefAvailability && !!chefAvailability.length && chefAvailability.length > 0) {
      let startTime = moment(moment(selectedTime).format(format), format);
      let endTime = moment(moment(selectedTimeEnd).format('hh:mm A'), 'hh:mm A');
      chefAvailability.forEach(availableSlot => {
        let beforeTime = moment(availableSlot.start, format),
          afterTime = moment(availableSlot.end, format).add(1, 'minute');

        if ((startTime.isBetween(beforeTime, afterTime) || startTime.isSameOrAfter(beforeTime)) && (endTime.isSameOrBefore(afterTime) || endTime.isBetween(beforeTime, afterTime)) && startTime.isBefore(endTime)) {
          chefAvail = true;
        }
      });
    }

    if (!chefAvail) {
      NotificationManager.error('Chef is not available for the selected slot.', 'Booking');
      return;
    }

    const payload = {
      userId,
      chefId  : props.chef.id,
      date    : moment(selectedDate),
      timeSlot: {
        start: selectedTime.format('HH:mm'),
        end  : selectedTimeEnd.format('HH:mm')
      },
      isCustom: true,
      isRecurring,
      message : state.description,
      dinerSize,
      startPrice,
      endPrice
    };

    if (isRecurring) {
      payload.repeatCount = repeatCount;
      payload.repeatDays = repeatDays;
    }

    if (state.selectedDishes.length) {
      payload.dishes = state.selectedDishes;
    }

    if (!city) {
      NotificationManager.error('Please update your address.');
      setState({ showAddress: true });
      return;
    }

    client
      .mutate({
        mutation   : CREATE_IN_PROGRESS_BOOKING,
        variables  : {
          booking: payload
        },
        fetchPolicy: 'no-cache'
      })
      .then(response => {
        dispatch(CreateInProgressBooking(response.data.createInProgressBooking));
        dispatch(setPendingBooking({
          ...payload,
          id: response.data.createInProgressBooking
        }));
        dispatch(setBookingCompletedStep(1));
        dispatch(setSelectedDate(new Date(payload.date)));
        dispatch(setSelectedSlot({
          start: moment(payload.timeSlot.start, 'HH:mm').format('HH:mm'),
          end  : moment(payload.timeSlot.end, 'HH:mm').format('HH:mm')
        }));
        props.changeProgressStep(2);
        if (window != undefined) {
          window.localStorage.setItem('cc-custom-booking-price-range', `${startPrice}-${endPrice}`)
        }
      })
      .catch(err => {
        console.log('Error creating recurring booking: ', err);
        let errorObj = JSON.parse(JSON.stringify(err));
        if (errorObj.graphQLErrors) {
          errorObj.graphQLErrors.forEach(error => {
            if (error.message.startsWith('Cannot make booking')) {
              NotificationManager.error('Please select a booking date and time that is at least 1 hour away to allow for the Chef to prepare for your booking.', 'Unable to book')
            } else if (error.message.includes('Your account cannot')) {
              NotificationManager.error('Chef has not completed the registration process.', 'Unable to book')
            } else {
              NotificationManager.error(error.message, 'Booking');
            }
          });
        }
      });

  };

  const isInSchedule = date => {
    const { monthlySlots } = state;

    if (monthlySlots) {
      const { getCalendarSlots } = monthlySlots;
      let isAvailable = false;

      if (getCalendarSlots)
        isAvailable = getCalendarSlots.find(day => {
          return day.date === moment(date).format("YYYY-MM-DD");
        });

      return !!isAvailable;
    }

    return false;
  }

  const renderWrappedWeekDay = (date, selectedDate, dayInCurrentMonth, dayComponent) => {
    let inDate = moment(date);
    const inCompDate = inDate.format("YYYY") + "-" + inDate.format("MM") + "-" + inDate.format("DD");
    inDate = moment(inCompDate);
    let today = moment(new Date());
    const compToday = today.format("YYYY") + "-" + today.format("MM") + "-" + today.format("DD");
    today = moment(compToday);

    if (inDate.isBefore(today)) {
      return <Badge>{dayComponent}</Badge>;
    }
    else {
      return <Badge badgeContent={<span
        style={{
          fontSize: 30,
          fontWeight: 500,
          color: isInSchedule(date) ? "green" : "white"
        }}
      >
                .
                </span>}>{dayComponent}</Badge>;
    }
  };

  return (
    <div>
      <Grid container>

        <Grid item xs={12}>
          <Typography
            style={{
              ...styles.setFont,
              fontSize    : 24,
              fontWeight  : 500,
              marginBottom: 30,
              color       : '#000000'
            }}
          >
            Review your booking
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Grid container justify={'space-between'} style={{ marginBottom: 30 }}>
            <Grid item xs={3} sm={2}>
              <img
                src={state.chef ? state.chef.profilePic ? state.chef.profilePic : defaultChefImg : defaultChefImg}
                style={styles.chefImg}
                alt={'Chef Name'}
              />

            </Grid>
            <Grid data-test-id={'bkgonechefname'} item xs={9} justify={'flex-start'}>
              <Typography
                style={{ ...styles.setFont, fontSize: 15, fontWeight: 400 }}
              >
                {`${state.chef ? state.chef.firstName.toUpperCase() : ''} ${state.chef ? state.chef.lastName ? state.chef.lastName.toUpperCase() : '' : ''}`}
              </Typography>
              <Typography>{state.chef ? state.chef.cuisines.length > 3 ? 'Multi Cuisines' : state.chef.cuisines.join(', ') : ''}</Typography>
            </Grid>
          </Grid>

          <div className="diner-details-time-wrapper booking-slider-inner-wrapper">
            <div className="diner-details-date-wrapper" style={{ width: '100%', marginRight: 0 }}>
              <div style={{
                display       : 'flex',
                alignItems    : 'center',
                marginBottom  : 30,
                justifyContent: 'space-between',
                borderBottom  : '1px inset rgba(0,0,0,0.25)',
                paddingBottom : 25
              }}>
                <div className="inner-label" style={{ fontWeight: 500, width: 125, fontSize: 18 }}>Date</div>
                <MuiPickersUtilsProvider utils={FrDateFnsUtils}>
                  <DatePicker
                    style={{ ...styles.setFont, color: primaryColor, display: 'none' }}
                    value={state.selectedDate}
                    animateYearScrolling
                    onChange={handleDateChange}
                    onMonthChange={date => {
                      setState({ scheduleMonth: moment(date).format('MM') })
                    }}
                    onAccept={(d) => {
                      openPicker()
                    }}
                    onClose={() => {
                      openPicker()
                    }}
                    minDate={state.minDate}
                    open={state.pickerRef}
                    renderDay={renderWrappedWeekDay}
                  />

                  <Typography
                    align={'right'}
                    style={{
                      ...styles.setFont,
                      fontSize  : 18,
                      color     : primaryColor,
                      marginLeft: 18
                    }}
                    onClick={openPicker}
                  >
                    {moment(state.selectedDate).format('DD MMM YYYY')}
                  </Typography>

                </MuiPickersUtilsProvider>
              </div>

              <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                <div className="inner-label" style={{ fontWeight: 500, width: 125, fontSize: 18 }}>Time</div>
                <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                  <div className="inner-label" style={{ fontWeight: 500, fontSize: 14, paddingLeft: 15 }}>FROM</div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Select
                      inputProps={{MenuProps: {disableScrollLock: true}}}
                      className="select-option"
                      data-test-id={'fromhour-id'}
                      value={state.selectedTimeHour}
                      style={{
                        fontSize  : '18px',
                        fontWeight: 300,
                        fontFamily: webFont, marginLeft: 20
                      }}
                      onChange={
                        evt => setState({ selectedTimeHour: evt.target.value })
                      }
                    >
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(monthDay => (
                        <MenuItem key={monthDay} value={monthDay} style={{
                          fontSize  : '18px',
                          fontWeight: 300,
                          fontFamily: webFont
                        }}>
                          {monthDay < 10 ? `0${monthDay}` : monthDay}
                        </MenuItem>
                      ))}

                    </Select>
                    <Select
                      inputProps={{MenuProps: {disableScrollLock: true}}}
                      className="select-option"
                      data-test-id={'fromminute-id'}
                      value={state.selectedTimeMinutes}
                      style={{
                        fontSize  : '18px',
                        fontWeight: 300,
                        fontFamily: webFont, marginLeft: 20
                      }}
                      onChange={
                        evt => setState({ selectedTimeMinutes: evt.target.value })
                      }
                    >
                      {['00', '15', '30', '45'].map(monthDay => (
                        <MenuItem key={monthDay} value={monthDay} style={{
                          fontSize  : '18px',
                          fontWeight: 300,
                          fontFamily: webFont
                        }}>
                          {monthDay}
                        </MenuItem>
                      ))}
                    </Select>

                    <Select
                      inputProps={{MenuProps: {disableScrollLock: true}}}
                      className="select-option"
                      data-test-id={'frommeridiem-id'}
                      value={state.selectedMeridiem}
                      onChange={
                        evt => setState({ selectedMeridiem: evt.target.value })
                      }
                      style={{
                        fontSize  : '18px',
                        fontWeight: 300,
                        fontFamily: webFont, marginLeft: 20
                      }}
                    >
                      <MenuItem value="AM">AM</MenuItem>
                      <MenuItem value="PM">PM</MenuItem>
                    </Select>
                  </div>
                </div>
              </div>

              <div style={{
                display       : 'flex',
                alignItems    : 'center',
                justifyContent: 'space-between',
                marginTop     : 20,
                borderBottom  : '1px inset rgba(0,0,0,0.25)',
                paddingBottom : 25
              }}>
                <div className="inner-label" style={{ fontWeight: 500, width: 125, fontSize: 18 }}></div>
                <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                  <div className="inner-label" style={{ fontWeight: 500, fontSize: 14, paddingLeft: 15 }}>TO</div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Select
                      inputProps={{MenuProps: {disableScrollLock: true}}}
                      className="select-option"
                      data-test-id={'fromhour-id'}
                      value={state.selectedTimeHourEnd}
                      style={{
                        fontSize  : '18px',
                        fontWeight: 300,
                        fontFamily: webFont, marginLeft: 20
                      }}
                      onChange={
                        evt => setState({ selectedTimeHourEnd: evt.target.value })
                      }
                    >
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(monthDay => (
                        <MenuItem key={monthDay} value={monthDay} style={{
                          fontSize  : '18px',
                          fontWeight: 300,
                          fontFamily: webFont
                        }}>
                          {monthDay < 10 ? `0${monthDay}` : monthDay}
                        </MenuItem>
                      ))}

                    </Select>
                    <Select
                      inputProps={{MenuProps: {disableScrollLock: true}}}
                      className="select-option"
                      data-test-id={'fromminute-id'}
                      value={state.selectedTimeMinutesEnd}
                      style={{
                        fontSize  : '18px',
                        fontWeight: 300,
                        fontFamily: webFont, marginLeft: 20
                      }}
                      onChange={
                        evt => setState({ selectedTimeMinutesEnd: evt.target.value })
                      }
                    >
                      {['00', '15', '30', '45'].map(monthDay => (
                        <MenuItem key={monthDay} value={monthDay} style={{
                          fontSize  : '18px',
                          fontWeight: 300,
                          fontFamily: webFont
                        }}>
                          {monthDay}
                        </MenuItem>
                      ))}
                    </Select>

                    <Select
                      inputProps={{MenuProps: {disableScrollLock: true}}}
                      className="select-option"
                      data-test-id={'frommeridiem-id'}
                      value={state.selectedMeridiemEnd}
                      onChange={
                        evt => setState({ selectedMeridiemEnd: evt.target.value })
                      }
                      style={{
                        fontSize  : '18px',
                        fontWeight: 300,
                        fontFamily: webFont, marginLeft: 20
                      }}
                    >
                      <MenuItem value="AM">AM</MenuItem>
                      <MenuItem value="PM">PM</MenuItem>
                    </Select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="diner-details-time-wrapper booking-slider-inner-wrapper">
            <div className="diner-details-date-wrapper" style={{ width: '100%', marginRight: 0 }}>
              <div style={{
                display       : 'flex',
                alignItems    : 'center',
                marginBottom  : 15,
                justifyContent: 'space-between',
                borderBottom  : '1px inset rgba(0,0,0,0.25)',
                padding       : '25px 0px'
              }}>
                {typeof chefAvailability === 'object' && chefAvailability ? `Chef Availability: ${state.availability.join(', ')}` : (
                  <FormHelperText id="component-error-text" style={styles.error}>
                    {chefAvailability}{' '}
                  </FormHelperText>
                )}
              </div>
            </div>
          </div>
        </Grid>

        <Grid item xs={12} style={{ display: 'flex', marginTop: 30 }}>
          <div className="diner-details-date-wrapper" style={{ width: '100%', marginRight: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div className="inner-label" style={{ fontWeight: 500, width: 130, fontSize: 18 }}>No. of Diners</div>
              <Input
                name={'dinerSize'}
                placeholder={'ex: 2'}
                label={'No. of Diners'}
                type={'number'}
                value={state.dinerSize}
                onChange={(e) => {
                  const val = e.target.value;
                  setState({ dinerSize: val });
                }}
                onBlur={(e) => {
                  const val = e.target.value;

                  if (val.length && /^\d+$/.test(val)) {
                    const convertedSize = parseInt(val);
                    if (convertedSize < 1) {
                      NotificationManager.error('Diner size cannot be less than 1', 'Booking');
                      setState({ dinerSize: val });
                    } else setState({ dinerSize: convertedSize });
                  } else {
                    NotificationManager.error('Enter valid number', 'Booking');
                    setState({ dinerSize: val });
                  }
                }}
                style={styles.inputText}
              />
            </div>
          </div>
        </Grid>

        <Grid item xs={12}
              style={{ display: 'flex', marginTop: 30, borderBottom: '1px inset rgba(0,0,0,0.25)', paddingBottom: 25 }}>
          <div className="diner-details-date-wrapper" style={{ width: '100%', marginRight: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span className="inner-label" style={{ fontWeight: 500, width: 130, fontSize: 18, marginRight: 110 }}>Price range</span>
              <Input
                name={'startPrice'}
                placeholder={'500'}
                label={'Start price'}
                type={'number'}
                value={state.startPrice}
                onChange={e => {
                  const val = e.target.value;
                  setState({ startPrice: val, priceErr: false, priceErrMsg: '' });
                }}
                onBlur={(e) => {
                  const val = e.target.value;

                  if (val.length && /^\d+$/.test(val)) {
                    const convertedSize = parseInt(val);
                    if (convertedSize < 1) {
                      setState({ startPrice: val, priceErr: true, priceErrMsg: 'Min price cannot be less than 1' });
                    } else setState({ startPrice: convertedSize, priceErr: false, priceErrMsg: '' });
                  } else {
                    setState({ startPrice: val, priceErr: true, priceErrMsg: 'Enter valid number' });
                  }
                }}
                style={styles.inputTextPrice}
                startAdornment={<InputAdornment position="start">$</InputAdornment>}
              />
              <span className="inner-label" style={{ fontWeight: 500 }}> to </span>
              <Input
                name={'endPrice'}
                placeholder={'10000'}
                label={'End price'}
                type={'number'}
                value={state.endPrice}
                onChange={e => {
                  const val = e.target.value;
                  setState({ endPrice: val, priceErr: false, priceErrMsg: '' });
                }}
                onBlur={(e) => {
                  const val = e.target.value;

                  if (val.length && /^\d+$/.test(val)) {
                    const convertedSize = parseInt(val);
                    if (convertedSize < 1 || convertedSize <= state.startPrice) {
                      setState({
                        endPrice   : val,
                        priceErr   : true,
                        priceErrMsg: 'Max price should be more than minimum price'
                      });
                    } else setState({ endPrice: convertedSize, priceErr: false, priceErrMsg: '' });
                  } else {
                    setState({ endPrice: val, priceErr: false, priceErrMsg: 'Enter valid number' });
                  }
                }}
                style={{ ...styles.inputTextPrice, marginLeft: 7 }}
                startAdornment={<InputAdornment position="start">$</InputAdornment>}
              />
            </div>
            {state.priceErr && <div style={{
              color    : 'red',
              fontSize : 12,
              width    : '100%',
              textAlign: 'right',
              marginTop: 5
            }}>{state.priceErrMsg}</div>}
          </div>
        </Grid>

        <Grid item xs={12} style={{ marginTop: 35 }}>
          <Typography
            variant="h5"
            align="left"
            style={{
              ...styles.setFont,
              fontWeight  : 500,
              fontSize    : 18,
              marginBottom: 20
            }}
          >
            Description
          </Typography>
          <TextField
            inputProps={{ 'data-test-id': 'pfbookingdesc' }}
            multiline
            variant="outlined"
            rows="7"
            placeholder="Is there an occasion? &#10;How many people will be there? &#10;What sort of dishes are you looking forward to? &#10;"
            fullWidth
            value={state.description}
            onChange={evt => {
              setState({ description: evt.target.value });
            }}
            style={{ ...styles.setFont }}
          />
          <div style={{ fontSize: 12, padding: '3px 5px' }}>
            Enter above dish names, any dietary restrictions, allergies or ingredients to avoid and what occasion you
            are hiring the Chef for.
          </div>
        </Grid>

        {/*<Grid item xs={12}>
          <ImageGallery
            autoPlay={false}
            items={state.galleryDishes}
            lazyLoad={true}
            infinte={true}
            sizes={'40vw'}
            showBullets={false}
            showFullscreenButton={false}
            showNav={true}
            showPlayButton={false}
            showThumbnails={true}
            showIndex={false}
            slideDuration={450}
            slideInterval={3500}
          />
        </Grid>*/}

      </Grid>

      <Modal
        disableEscapeKeyDown={true}
        onClose={() => {
        }}
        open={state.showAddress}
        aria-labelledby={'address-dialog'}
        className="custom-address-step3">
        <Grid style={{
          padding        : '20px 30px',
          maxWidth       : 500,
          backgroundColor: '#fff',
          margin         : '60px auto',
          maxHeight      : '80vh',
          overflow       : 'scroll'
        }}>
          <div className="close-icon-address-step3" onClick={() => setState({ showAddress: false })}>
            <Close/>
          </div>
          <AddressComp stepOne={true} closeModal={showAddressToggle}/>
        </Grid>
      </Modal>

      <Grid container style={{ marginTop: 40, marginBottom: 10, alignItems: 'center' }} justify="center"
            direction="column">
        <Grid item>
          <Button
            data-test-id={'bkgonenext'}
            style={{ ...styles.setFont, ...styles.nextBtn }}
            onClick={inProgress}
          >
            Next
          </Button>
        </Grid>

        {/*<Grid item xs={12} style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 15 }}>
          <Button
            data-test-id={"bkgoneaddupd"}
            style={{...styles.setFont, ...styles.updateBtn}}
            onClick={showAddressToggle}
          >
            Update address
          </Button>
        </Grid>*/}
      </Grid>
    </div>
  );
}

export default InProgressRecurring1;

const styles = {
  setFont       : {
    fontFamily: webFont
  },
  error         : { fontSize: 12, color: 'red', fontFamily: webFont },
  chefImg       : {
    width : 60,
    height: 60,
    // objectFit: "contain",
    borderRadius: '50%'
  },
  inputText     : {
    fontFamily: webFont,
    fontSize  : 18,
    fontWeight: 300,
    marginLeft: 15,
    textAlign : 'center',
    width     : 40
  },
  inputTextPrice: {
    fontFamily: webFont,
    fontSize  : 16,
    fontWeight: 300,
    marginLeft: 15,
    textAlign : 'center',
    width     : 70
  },
  nextBtn       : {
    minWidth       : 240,
    height         : 48,
    textAlign      : 'center',
    borderRadius   : 24,
    backgroundColor: primaryColor,
    color          : '#fff',
    textTransform  : 'none',
    fontWeight     : 'normal',
    fontSize       : 18
  },
  setColor      : {
    color: primaryColor
  },
  setRoundedIcon: {
    borderRadius: '50%',
    borderColor : primaryColor
  },
  updateBtn     : {
    minWidth       : 240,
    height         : 48,
    textAlign      : 'center',
    borderRadius   : 24,
    borderColor    : primaryColor,
    borderWidth    : 1,
    color          : primaryColor,
    backgroundColor: '#fff',
    textTransform  : 'none',
    fontSize       : 18,
    fontWeight     : 'normal',
    marginTop      : 5
  }
};
